import { createAsyncThunk } from '@reduxjs/toolkit';

import { config } from '@platform/constants';
import { httpService } from '@shared/utilities';
import { AscResponse } from '@shared/models';
import * as Response from '@shared/models/dashboard/dashboard.response.type';
import * as Request from '@shared/models/dashboard/dashboard.request.type';
import { formatErrorMessage } from '@ascendnow/ascend-components';
import { setAssesmentQuestions, setAssesmentResults } from '../slices/baseline-assesment.slice';

export const BaselineAssesmentEndpoints = {
    getAssesments: config.base_url + '/baseline-assessment/questions',
    getAssesmentResults: config.base_url + '/baseline-assessment/results?globals=true',
    submitAssesment: config.base_url + '/baseline-assessment/submit',
};

export const fetchAssesments = createAsyncThunk<void, Request.IBaselineAssesmentQueryType>(
    BaselineAssesmentEndpoints.getAssesments,
    async (query, { dispatch }) => {
        try {
            const res = await httpService.get<AscResponse<Response.IBaselineQuestionsResponseType>>(
                `${BaselineAssesmentEndpoints.getAssesments}`
            );
            dispatch(setAssesmentQuestions(res.data.data.assessment));

            if (query.cb && query.cb.onSuccess) {
                query.cb.onSuccess(res.data.data);
            }
        } catch (err) {
            if (query.cb && query.cb.onError) {
                query.cb.onError(err);
            }
            console.log(
                formatErrorMessage(
                    err,
                    `Error fetching assesment questions , query: ${BaselineAssesmentEndpoints.getAssesments}`
                ),
                { type: 'error' }
            );
        }
    }
);

export const fetchAssesmentResults = createAsyncThunk<void, Request.IBaselineAssesmentQueryType>(
    BaselineAssesmentEndpoints.getAssesmentResults,
    async (query, { dispatch }) => {
        try {
            const res = await httpService.get<AscResponse<Response.IBaselineResultsResponseType>>(
                `${BaselineAssesmentEndpoints.getAssesmentResults}`
            );

            dispatch(setAssesmentResults(res.data.data.results));

            if (query.cb && query.cb.onSuccess) {
                query.cb.onSuccess(res.data.data);
            }
        } catch (err) {
            if (query.cb && query.cb.onError) {
                query.cb.onError(err);
            }
            console.log(
                formatErrorMessage(
                    err,
                    `Error fetching assesment results of dashboard, query: ${BaselineAssesmentEndpoints.getAssesmentResults}`
                ),
                { type: 'error' }
            );
        }
    }
);

export const postAssesment = createAsyncThunk<void, Request.IBaselineSubmitAssesmentQueryType>(
    BaselineAssesmentEndpoints.submitAssesment,
    async (query) => {
        try {
            const res = await httpService.post(`${BaselineAssesmentEndpoints.submitAssesment}`, query.data);

            if (query.cb && query.cb.onSuccess) {
                query.cb.onSuccess(res.data.data);
            }
        } catch (err) {
            console.log(
                formatErrorMessage(
                    err,
                    `Error submitting assesment data of platform, query: ${BaselineAssesmentEndpoints.submitAssesment}`
                ),
                { type: 'error' }
            );
        }
    }
);
